// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { css } from "styled-components";

headerStyles.title = {
    variant: "h2",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.buttonGridItem = {
    css: css`
        justify-content: flex-end;
        padding: 15px;
    `,
    width: [2, 2, 2, 9, 8],
};
